import { Box } from '@mui/material';

export function Loader({
  variant = 'default',
  className = '',
}: {
  variant?: 'default' | 'inline';
  className?: string;
}) {
  return (
    <Box className={`flex justify-center h-full items-center ${className}`}>
      {variant === 'default' && (
        <i className='line-md-loading-loop w-[50px] h-[50px]' />
      )}
      {variant === 'inline' && (
        <i className='line-md-loading-loop w-[24px] h-[24px]' />
      )}
    </Box>
  );
}
